import { useMemo } from 'react';
import { useGetEditOrActual } from '../../../../../state/CampaignSettings/selectors/useGetEditOrActual';

export const useSegmentSchedulingSelector = (messageId: string) => {
  const state = useGetEditOrActual();

  const message = state.messages[messageId];
  const scheduling = message?.scheduling;

  return useMemo(
    () => ({
      startDate: scheduling?.startDate,
      endDate: scheduling?.endDate,
      startTime: scheduling?.startTime,
      endTime: scheduling?.endTime,
    }),
    [scheduling],
  );
};
